// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";

function getVaultModeFromName(val) {
  switch (val) {
    case "hyperswitch" :
      return "Hyperswitch";
    case "vgs" :
      return "VeryGoodSecurity";
    default:
      return "None";
  }
}

function getVaultName(sessionObj) {
  if (typeof sessionObj !== "object") {
    return "";
  }
  if (sessionObj.TAG !== "Loaded") {
    return "";
  }
  let dict = Utils$OrcaPaymentPage.getDictFromJson(sessionObj._0);
  return Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromDict(dict, "vault_details"), "vault_type", "");
}

function buildHyperswitchVaultConfig(sessionObj) {
  if (typeof sessionObj !== "object") {
    return {};
  }
  if (sessionObj.TAG !== "Loaded") {
    return {};
  }
  let dict = Utils$OrcaPaymentPage.getDictFromJson(sessionObj._0);
  let vaultData = Utils$OrcaPaymentPage.getDictFromDict(Utils$OrcaPaymentPage.getDictFromDict(dict, "vault_details"), "vault_data");
  let sdkAuthorization = Utils$OrcaPaymentPage.getString(vaultData, "sdk_authorization", "");
  let authData = Utils$OrcaPaymentPage.getSdkAuthorizationData(sdkAuthorization);
  return Object.fromEntries([
    [
      "sdkAuthorization",
      sdkAuthorization
    ],
    [
      "pmSessionId",
      Core__Option.getOr(authData.pmSessionId, "")
    ]
  ]);
}

function buildVGSVaultConfig(sessionObj) {
  if (typeof sessionObj !== "object") {
    return {};
  }
  if (sessionObj.TAG !== "Loaded") {
    return {};
  }
  let dict = Utils$OrcaPaymentPage.getDictFromJson(sessionObj._0);
  let vaultData = Utils$OrcaPaymentPage.getDictFromDict(Utils$OrcaPaymentPage.getDictFromDict(dict, "vault_details"), "vault_data");
  return Object.fromEntries([
    [
      "vaultId",
      Utils$OrcaPaymentPage.getString(vaultData, "vault_id", "")
    ],
    [
      "environment",
      Utils$OrcaPaymentPage.getString(vaultData, "environment", "")
    ]
  ]);
}

function buildVaultConfig(sessionObj, vaultMode) {
  switch (vaultMode) {
    case "VeryGoodSecurity" :
      return buildVGSVaultConfig(sessionObj);
    case "Hyperswitch" :
      return buildHyperswitchVaultConfig(sessionObj);
    case "None" :
      return {};
  }
}

function decodeHyperswitchVaultConfig(json) {
  let dict = Utils$OrcaPaymentPage.getDictFromJson(json);
  return {
    TAG: "HyperswitchVault",
    _0: {
      sdkAuthorization: Utils$OrcaPaymentPage.getString(dict, "sdkAuthorization", ""),
      pmSessionId: Utils$OrcaPaymentPage.getString(dict, "pmSessionId", "")
    }
  };
}

function decodeVGSVaultConfig(json) {
  let dict = Utils$OrcaPaymentPage.getDictFromJson(json);
  return {
    TAG: "VGS",
    _0: {
      vaultId: Utils$OrcaPaymentPage.getString(dict, "vaultId", ""),
      environment: Utils$OrcaPaymentPage.getString(dict, "environment", "")
    }
  };
}

function decodeVaultCredentials(vaultModeStr, json) {
  let match = getVaultModeFromName(vaultModeStr);
  switch (match) {
    case "VeryGoodSecurity" :
      return decodeVGSVaultConfig(json);
    case "Hyperswitch" :
      return decodeHyperswitchVaultConfig(json);
    case "None" :
      return "NoVault";
  }
}

function getVaultCredentialsFromSessions(sessionObj) {
  let vaultName = getVaultName(sessionObj);
  let vaultMode = getVaultModeFromName(vaultName);
  return decodeVaultCredentials(vaultName, buildVaultConfig(sessionObj, vaultMode));
}

function decodeVaultTokenData(vaultResponse) {
  let vaultDict = Utils$OrcaPaymentPage.getDictFromJson(vaultResponse);
  let sessionResponse = Utils$OrcaPaymentPage.getArray(vaultDict, "associated_payment_methods");
  let tokenEntry = Core__Option.getOr(Core__Option.flatMap(sessionResponse[0], Core__JSON.Decode.object), {});
  let tokenDict = Utils$OrcaPaymentPage.getDictFromJson(Utils$OrcaPaymentPage.getJsonObjectFromDict(tokenEntry, "payment_method_token"));
  let token = Utils$OrcaPaymentPage.getString(tokenDict, "data", "");
  let cardDict = Utils$OrcaPaymentPage.getDictFromDict(Utils$OrcaPaymentPage.getDictFromDict(vaultDict, "payment_method_data"), "card");
  let last4Digits = Utils$OrcaPaymentPage.getString(cardDict, "last4_digits", "");
  let binNumber = Utils$OrcaPaymentPage.getString(cardDict, "card_isin", "");
  let expiryMonth = Utils$OrcaPaymentPage.getString(cardDict, "expiry_month", "");
  let expiryYear = Utils$OrcaPaymentPage.getString(cardDict, "expiry_year", "");
  return {
    token: token,
    last4Digits: last4Digits,
    binNumber: binNumber,
    expiryMonth: expiryMonth,
    expiryYear: expiryYear
  };
}

let defaultVaultCredentials = "NoVault";

export {
  defaultVaultCredentials,
  getVaultModeFromName,
  getVaultName,
  buildHyperswitchVaultConfig,
  buildVGSVaultConfig,
  buildVaultConfig,
  decodeHyperswitchVaultConfig,
  decodeVGSVaultConfig,
  decodeVaultCredentials,
  getVaultCredentialsFromSessions,
  decodeVaultTokenData,
}
/* Utils-OrcaPaymentPage Not a pure module */
